// function StepPricingAccess({ type, values, onChange, onNext, onBack }) {
//   // Handle price change
//   const handlePriceChange = (e) => {
//     const val = e.target.value;
//     onChange({ ...values, price: val === "0" ? 0 : Number(val) });
//   };

//   // Toggle free/paid for links
//   const handlePreviewToggle = (i, checked) => {
//     const links = [...(values.youtubeLinks || [])];
//     links[i].showFree = checked;
//     onChange({ ...values, youtubeLinks: links });
//   };

//   // Toggle PDF previewable
//   const handlePdfPreviewToggle = () => {
//     onChange({ ...values, pdfPreviewable: !values.pdfPreviewable });
//   };

//   return (
//     <form
//       className="flex flex-col gap-6"
//       onSubmit={(e) => {
//         e.preventDefault();
//         onNext();
//       }}
//     >
//       {/* Price Input */}
//       <div className="flex flex-col gap-2">
//         <label className="font-semibold">Price (LKR)</label>
//         <input
//           type="number"
//           min="0"
//           step="0.01"
//           className="w-full p-2 rounded-xl border bg-gray-50"
//           value={values.price ?? ""}
//           onChange={handlePriceChange}
//           required
//         />
//         <span className="text-xs text-gray-400">
//           Enter 0 for Free {type === "course" ? "Course" : "Product"}
//         </span>
//       </div>

//       {/* YouTube link access */}
//       {(values.youtubeLinks || []).length > 0 && (
//         <div className="flex flex-col gap-2 bg-gray-50 rounded-2xl p-4">
//           <div className="font-semibold mb-2">Set Access for YouTube Links</div>
//           <div className="max-h-96 overflow-y-auto pr-2">
//             {(values.youtubeLinks || []).map((link, i) => (
//               <div key={i} className="flex items-center gap-2 mb-1">
//                 <span className="truncate text-sm text-blue-700 font-medium">
//                   {link.url}
//                 </span>
//                 <label className="flex items-center gap-1 ml-2 text-xs font-medium">
//                   <input
//                     type="checkbox"
//                     checked={link.showFree}
//                     onChange={(e) => handlePreviewToggle(i, e.target.checked)}
//                     className="accent-blue-600"
//                   />
//                   Preview for free
//                 </label>
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* PDF previewable toggle */}
//       {values.pdf && (
//         <label className="flex items-center gap-2 font-medium bg-gray-50 rounded-xl p-3">
//           <input
//             type="checkbox"
//             checked={!!values.pdfPreviewable}
//             onChange={handlePdfPreviewToggle}
//             className="accent-blue-600"
//           />
//           Allow preview/download of PDF before purchase
//         </label>
//       )}

//       {/* Navigation buttons */}
//       <div className="flex gap-2 justify-end pt-2">
//         <button
//           type="button"
//           className="px-4 py-2 rounded-xl bg-gray-100 text-gray-600"
//           onClick={onBack}
//         >
//           Back
//         </button>
//         <button
//           type="submit"
//           className="px-6 py-2 rounded-xl bg-blue-600 text-white font-semibold hover:bg-blue-700"
//         >
//           Next
//         </button>
//       </div>
//     </form>
//   );
// }

// export default StepPricingAccess;

import { useMemo } from "react";
import { splitAffiliateCommission } from "../../utils/affiliateCommission";

export default function StepPricingAccess({
  type,
  values,
  onChange,
  onNext,
  onBack,
}) {
  const t = (type || "").toLowerCase();
  const isCourse = t === "course";
  const isProduct = t === "product";
  const isService = t === "service";

  // ---------- helpers ----------
  const ytLinks = useMemo(
    () => (Array.isArray(values.youtubeLinks) ? values.youtubeLinks : []),
    [values.youtubeLinks],
  );
  const courseHasAnyPdf = useMemo(() => {
    const global = Array.isArray(values.pdfLinks) ? values.pdfLinks.length : 0;
    const perVid = ytLinks.reduce(
      (sum, l) => sum + (Array.isArray(l.pdfs) ? l.pdfs.length : 0),
      0,
    );
    return global + perVid > 0;
  }, [values.pdfLinks, ytLinks]);

  const handlePriceChange = (e) => {
    const val = e.target.value;
    onChange({ ...values, price: val === "" ? "" : Number(val) });
  };

  // course: toggle per-link visibility
  const handlePreviewToggle = (i, checked) => {
    const links = [...ytLinks];
    links[i] = { ...(links[i] || {}), showFree: !!checked };
    onChange({ ...values, youtubeLinks: links });
  };

  // course: global pdf preview toggle
  const handlePdfPreviewToggle = () => {
    onChange({ ...values, pdfPreviewable: !values.pdfPreviewable });
  };

  // ---------- service pricing state ----------
  const pricingType = values.pricingType || "fixed"; // "fixed" | "hourly"
  const hourlyRate = values.hourlyRate ?? "";
  const minHours = values.minHours ?? "";
  const deliveryDays = values.deliveryDays ?? "";
  const revisions = values.revisions ?? 0;
  const depositPct = values.depositPct ?? ""; // optional
  const allowDiscovery = !!values.allowDiscovery;

  const set = (patch) => onChange({ ...values, ...patch });

  const affiliateEnabled = !!values.affiliateEnabled;
  const affiliateCommissionAmount = values.affiliateCommissionAmount ?? "";
  const wholesaleEnabled = !!values.wholesaleEnabled;
  const wholesaleMinQty = values.wholesaleMinQty ?? "";
  const wholesalePrice = values.wholesalePrice ?? "";
  const wholesalePhone = values.wholesalePhone ?? "";

  const handleAffiliateToggle = (checked) => {
    const total = checked
      ? Number(values.affiliateCommissionAmount || 0) || 0
      : 0;
    const byLevel = splitAffiliateCommission(total).byLevel;
    onChange({
      ...values,
      affiliateEnabled: checked,
      affiliateCommissionAmount: total,
      affiliateLevel1Amount: byLevel[1],
      affiliateLevel2Amount: byLevel[2],
      affiliateLevel3Amount: byLevel[3],
      affiliateCommissionByLevel: byLevel,
      affiliateTotalCommissionAmount: total,
      affiliateSplitModel: checked ? "fixed_50_30_20" : null,
    });
  };

  const handleAffiliateCommissionChange = (e) => {
    const next = e.target.value;
    const total = next === "" ? "" : Number(next);
    const byLevel =
      next === ""
        ? { 1: 0, 2: 0, 3: 0 }
        : splitAffiliateCommission(total).byLevel;
    onChange({
      ...values,
      affiliateCommissionAmount: total,
      affiliateLevel1Amount: byLevel[1],
      affiliateLevel2Amount: byLevel[2],
      affiliateLevel3Amount: byLevel[3],
      affiliateCommissionByLevel: byLevel,
      affiliateTotalCommissionAmount: next === "" ? 0 : Number(total || 0) || 0,
      affiliateSplitModel: "fixed_50_30_20",
    });
  };

  const handleWholesaleToggle = (checked) => {
    onChange({
      ...values,
      wholesaleEnabled: checked,
      wholesaleMinQty: checked ? values.wholesaleMinQty ?? 10 : "",
      wholesalePrice: checked ? values.wholesalePrice ?? "" : "",
      wholesalePhone: checked ? values.wholesalePhone ?? "" : "",
    });
  };

  const validateAndNext = (e) => {
    e.preventDefault();
    if (isService) {
      if (pricingType === "fixed") {
        if (
          values.price == null ||
          values.price === "" ||
          Number(values.price) < 0
        ) {
          alert("Please enter a valid fixed price.");
          return;
        }
      } else {
        if (hourlyRate === "" || Number(hourlyRate) <= 0) {
          alert("Please enter a valid hourly rate.");
          return;
        }
        if (minHours === "" || Number(minHours) <= 0) {
          alert("Please enter a valid minimum hours.");
          return;
        }
      }
      if (deliveryDays !== "" && Number(deliveryDays) < 0) {
        alert("Delivery days can't be negative.");
        return;
      }
      if (revisions !== "" && Number(revisions) < 0) {
        alert("Revisions can't be negative.");
        return;
      }
    }

    if (isProduct || isCourse) {
      if (values.price === "" || Number(values.price) < 0) {
        alert("Please enter a valid price (use 0 for Free).");
        return;
      }
    }

    if (isProduct && wholesaleEnabled) {
      if (
        wholesaleMinQty === "" ||
        !Number.isFinite(Number(wholesaleMinQty)) ||
        Number(wholesaleMinQty) < 2
      ) {
        alert("Please enter a wholesale minimum quantity of 2 or more.");
        return;
      }
      if (
        wholesalePrice === "" ||
        !Number.isFinite(Number(wholesalePrice)) ||
        Number(wholesalePrice) < 0
      ) {
        alert("Please enter a valid wholesale unit price.");
        return;
      }
      if (!String(wholesalePhone || "").trim()) {
        alert("Please add the mobile number buyers can see for wholesale orders.");
        return;
      }
      if (
        values.stock != null &&
        values.stock !== "" &&
        Number.isFinite(Number(values.stock)) &&
        Number(wholesaleMinQty) > Number(values.stock)
      ) {
        alert(
          "Wholesale minimum quantity cannot be higher than your current stock.",
        );
        return;
      }
    }

    if (affiliateEnabled) {
      if (
        affiliateCommissionAmount === "" ||
        Number(affiliateCommissionAmount) < 0
      ) {
        alert("Please enter a valid affiliate share amount.");
        return;
      }
    }

    onNext();
  };

  return (
    <form className="flex flex-col gap-6" onSubmit={validateAndNext}>
      {/* ======== PRICE ======== */}
      {(isCourse || isProduct) && (
        <div className="flex flex-col gap-2">
          <label className="font-semibold">
            {isProduct ? "Retail Price (LKR)" : "Price (LKR)"}
          </label>
          <input
            type="number"
            min="0"
            step="0.01"
            className="w-full p-2 rounded-xl border bg-gray-50"
            value={values.price ?? ""}
            readOnly={isProduct && Boolean(values.variants?.length)}
            onChange={handlePriceChange}
            required
          />
          <span className="text-xs text-gray-400">
            {isProduct && values.variants?.length ? "Starting price is calculated from variations. Edit individual prices in the previous step." : `Enter 0 for Free ${isCourse ? "Course" : "Product"}`}
          </span>
        </div>
      )}

      {isProduct && (
        <div className="rounded-2xl border border-emerald-100 bg-emerald-50/70 p-4">
          <div className="font-semibold text-gray-900">
            Retail And Wholesale Setup
          </div>
          <p className="mt-1 text-sm text-gray-600">
            Keep your normal retail price above, then optionally unlock a
            separate wholesale unit price for buyers who order in bulk.
          </p>

          <label className="mt-3 inline-flex items-center gap-3 text-sm font-medium text-gray-700">
            <input
              type="checkbox"
              className="h-4 w-4 accent-emerald-600"
              checked={wholesaleEnabled}
              onChange={(e) => handleWholesaleToggle(e.target.checked)}
            />
            Offer wholesale pricing for bulk buyers
          </label>

          {wholesaleEnabled ? (
            <div className="mt-4 grid gap-4 sm:grid-cols-3">
              <label className="font-medium flex flex-col gap-1">
                Minimum wholesale quantity
                <input
                  type="number"
                  min="2"
                  step="1"
                  className="w-full p-2 rounded-xl border bg-white"
                  value={wholesaleMinQty}
                  onChange={(e) =>
                    set({
                      wholesaleMinQty:
                        e.target.value === "" ? "" : Number(e.target.value),
                    })
                  }
                  placeholder="e.g. 12"
                />
              </label>
              <label className="font-medium flex flex-col gap-1">
                Wholesale unit price (LKR)
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  className="w-full p-2 rounded-xl border bg-white"
                  value={wholesalePrice}
                  onChange={(e) =>
                    set({
                      wholesalePrice:
                        e.target.value === "" ? "" : Number(e.target.value),
                    })
                  }
                  placeholder="e.g. 1750"
                />
              </label>
              <label className="font-medium flex flex-col gap-1">
                Wholesale contact mobile
                <input
                  type="text"
                  className="w-full p-2 rounded-xl border bg-white"
                  value={wholesalePhone}
                  onChange={(e) => set({ wholesalePhone: e.target.value })}
                  placeholder="e.g. +94 77 123 4567"
                />
              </label>
            </div>
          ) : null}

          {wholesaleEnabled && !values.variants?.length && <label className="mt-4 block text-sm font-medium">Wholesale options (optional, one per line)
            <textarea rows={3} className="mt-2 w-full rounded-xl border p-3" value={Array.isArray(values.wholesaleOptions) ? values.wholesaleOptions.join("\n") : values.wholesaleOptions || ""} onChange={(e) => set({ wholesaleOptions: e.target.value })} placeholder={"Small / Black\nMedium / Black\nLarge / White"} />
            <span className="mt-1 block text-xs font-normal text-gray-600">Leave empty to use the product’s sizes, colors or other list specifications. Add custom models, packs or combinations here when needed. Buyers enter a quantity for each option; stock is tracked for the product as a whole.</span>
          </label>}
          {wholesaleEnabled && Boolean(values.variants?.length) && <p className="mt-3 text-sm">Wholesale price and minimum quantity apply to each selected variation. Stock is tracked separately per variation.</p>}
          {wholesaleEnabled ? (
            <div className="mt-3 rounded-xl border border-emerald-200 bg-white/80 px-3 py-2 text-xs leading-5 text-gray-600">
              Buyers will only see this mobile number when they choose wholesale
              and meet the minimum quantity.
            </div>
          ) : null}
          {wholesaleEnabled &&
          values.stock != null &&
          values.stock !== "" &&
          Number(values.stock) < Number(wholesaleMinQty || 0) ? (
            <div className="mt-3 rounded-xl border border-amber-200 bg-amber-50 px-3 py-2 text-xs leading-5 text-amber-800">
              Your current stock is below the wholesale minimum, so wholesale
              will stay unavailable until you increase stock or lower the
              minimum quantity.
            </div>
          ) : null}
        </div>
      )}

      <div className="rounded-2xl border border-blue-100 bg-blue-50/60 p-4 flex flex-col gap-3">
        <div>
          <div className="font-semibold text-gray-900">Affiliate Promotion</div>
          <p className="text-sm text-gray-600 mt-1">
            Choose whether affiliates can promote this listing, then enter the
            total amount you want to share per approved sale. This share comes
            out of your listed price, not on top of it.
          </p>
        </div>

        <label className="inline-flex items-center gap-3 text-sm font-medium text-gray-700">
          <input
            type="checkbox"
            className="h-4 w-4 accent-blue-600"
            checked={affiliateEnabled}
            onChange={(e) => handleAffiliateToggle(e.target.checked)}
          />
          Allow affiliates to promote this item
        </label>

        {affiliateEnabled && (
          <div className="grid gap-4">
            <div className="flex flex-col gap-2">
              <label className="font-semibold">
                Affiliate share amount (LKR)
              </label>
              <input
                type="number"
                min="0"
                step="0.01"
                className="w-full p-2 rounded-xl border bg-white"
                value={affiliateCommissionAmount}
                onChange={handleAffiliateCommissionChange}
                required
              />
            </div>
            {/* <div className="grid gap-3 sm:grid-cols-3">
              <div className="rounded-2xl border bg-white p-3">
                <div className="text-xs font-semibold uppercase tracking-wide text-gray-500">
                  Direct sale
                </div>
                <div className="mt-1 font-bold text-gray-900">
                  LKR {Number(affiliatePreview.byLevel[1] || 0).toLocaleString("en-LK")}
                </div>
                <div className="mt-1 text-xs text-gray-500">
                  50% to the person who shared the link
                </div>
              </div>
              <div className="rounded-2xl border bg-white p-3">
                <div className="text-xs font-semibold uppercase tracking-wide text-gray-500">
                  Upline level 2
                </div>
                <div className="mt-1 font-bold text-gray-900">
                  LKR {Number(affiliatePreview.byLevel[2] || 0).toLocaleString("en-LK")}
                </div>
                <div className="mt-1 text-xs text-gray-500">
                  30% to the next upline
                </div>
              </div>
              <div className="rounded-2xl border bg-white p-3">
                <div className="text-xs font-semibold uppercase tracking-wide text-gray-500">
                  Upline level 3
                </div>
                <div className="mt-1 font-bold text-gray-900">
                  LKR {Number(affiliatePreview.byLevel[3] || 0).toLocaleString("en-LK")}
                </div>
                <div className="mt-1 text-xs text-gray-500">
                  20% to the third level
                </div>
              </div>
            </div>
            <span className="text-xs text-gray-500">
              The system auto-splits this amount as 50% direct, 30% next
              upline, and 20% third level. If some uplines do not exist, the
              remaining share stays in a separate admin pool.
            </span> */}
          </div>
        )}
      </div>

      {/* ======== SERVICE PRICING ======== */}
      {isService && (
        <div className="grid gap-4">
          <div className="flex flex-col gap-2">
            <label className="font-semibold">Pricing Model</label>
            <div className="flex flex-wrap gap-3">
              {[
                { key: "fixed", label: "Fixed price" },
                { key: "hourly", label: "Hourly" },
              ].map((opt) => (
                <label
                  key={opt.key}
                  className={`px-3 py-2 rounded-xl border cursor-pointer select-none ${
                    pricingType === opt.key
                      ? "bg-emerald-50 border-emerald-300"
                      : "bg-gray-50 border-gray-200"
                  }`}
                >
                  <input
                    type="radio"
                    className="mr-2 align-middle"
                    checked={pricingType === opt.key}
                    onChange={() => set({ pricingType: opt.key })}
                  />
                  {opt.label}
                </label>
              ))}
            </div>
          </div>

          {pricingType === "fixed" ? (
            <div className="flex flex-col gap-2">
              <label className="font-semibold">Fixed Price (LKR)</label>
              <input
                type="number"
                min="0"
                step="0.01"
                className="w-full p-2 rounded-xl border bg-gray-50"
                value={values.price ?? ""}
                onChange={handlePriceChange}
                required
              />
              <span className="text-xs text-gray-400">
                Use 0 for Free consultation / discovery-only offers.
              </span>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <label className="font-medium flex flex-col gap-1">
                Hourly Rate (LKR)
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  className="w-full p-2 rounded-xl border bg-gray-50"
                  value={hourlyRate}
                  onChange={(e) =>
                    set({
                      hourlyRate:
                        e.target.value === "" ? "" : Number(e.target.value),
                    })
                  }
                  required
                />
              </label>
              <label className="font-medium flex flex-col gap-1">
                Minimum Hours
                <input
                  type="number"
                  min="1"
                  step="1"
                  className="w-full p-2 rounded-xl border bg-gray-50"
                  value={minHours}
                  onChange={(e) =>
                    set({
                      minHours:
                        e.target.value === "" ? "" : Number(e.target.value),
                    })
                  }
                  required
                />
              </label>
            </div>
          )}

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <label className="font-medium flex flex-col gap-1">
              Estimated Delivery (days)
              <input
                type="number"
                min="0"
                step="1"
                className="w-full p-2 rounded-xl border bg-gray-50"
                value={deliveryDays}
                onChange={(e) =>
                  set({
                    deliveryDays:
                      e.target.value === "" ? "" : Number(e.target.value),
                  })
                }
                placeholder="e.g. 7"
              />
            </label>
            <label className="font-medium flex flex-col gap-1">
              Revisions Included
              <input
                type="number"
                min="0"
                step="1"
                className="w-full p-2 rounded-xl border bg-gray-50"
                value={revisions}
                onChange={(e) =>
                  set({
                    revisions:
                      e.target.value === "" ? "" : Number(e.target.value),
                  })
                }
                placeholder="e.g. 2"
              />
            </label>
            <label className="font-medium flex flex-col gap-1">
              Upfront Deposit (%)
              <input
                type="number"
                min="0"
                max="100"
                step="1"
                className="w-full p-2 rounded-xl border bg-gray-50"
                value={depositPct}
                onChange={(e) =>
                  set({
                    depositPct:
                      e.target.value === "" ? "" : Number(e.target.value),
                  })
                }
                placeholder="optional"
              />
            </label>
          </div>

          <label className="flex items-center gap-2 font-medium bg-emerald-50 rounded-xl p-3 border border-emerald-200">
            <input
              type="checkbox"
              checked={allowDiscovery}
              onChange={(e) => set({ allowDiscovery: e.target.checked })}
              className="accent-emerald-600"
            />
            Offer a free discovery call
          </label>

          {Array.isArray(values.contactMethods) &&
            values.contactMethods.length > 0 && (
              <div className="text-xs text-gray-600">
                Preferred contact:{" "}
                <span className="font-semibold">
                  {values.contactMethods.join(", ")}
                </span>
              </div>
            )}
        </div>
      )}

      {/* ======== ACCESS CONTROLS FOR COURSES ======== */}
      {isCourse && ytLinks.length > 0 && (
        <div className="flex flex-col gap-2 bg-gray-50 rounded-2xl p-4">
          <div className="font-semibold mb-2">Set Access for YouTube Links</div>
          <div className="max-h-96 overflow-y-auto pr-2">
            {ytLinks.map((link, i) => (
              <div key={i} className="flex items-center gap-2 mb-1">
                <span className="truncate text-sm text-blue-700 font-medium">
                  {link.url}
                </span>
                <label className="flex items-center gap-1 ml-2 text-xs font-medium">
                  <input
                    type="checkbox"
                    checked={!!link.showFree}
                    onChange={(e) => handlePreviewToggle(i, e.target.checked)}
                    className="accent-blue-600"
                  />
                  Preview for free
                </label>
              </div>
            ))}
          </div>
        </div>
      )}

      {isCourse && courseHasAnyPdf && (
        <label className="flex items-center gap-2 font-medium bg-gray-50 rounded-xl p-3">
          <input
            type="checkbox"
            checked={!!values.pdfPreviewable}
            onChange={handlePdfPreviewToggle}
            className="accent-blue-600"
          />
          Allow preview/download of PDFs before purchase
        </label>
      )}

      {/* ======== NAV ======== */}
      <div className="flex gap-2 justify-end pt-2">
        <button
          type="button"
          className="px-4 py-2 rounded-xl bg-gray-100 text-gray-600"
          onClick={onBack}
        >
          Back
        </button>
        <button
          type="submit"
          className="px-6 py-2 rounded-xl bg-blue-600 text-white font-semibold hover:bg-blue-700"
        >
          Next
        </button>
      </div>
    </form>
  );
}
